import { render, staticRenderFns } from "./ScopeSelect.vue?vue&type=template&id=4375d670&scoped=true"
import script from "./ScopeSelect.vue?vue&type=script&lang=js"
export * from "./ScopeSelect.vue?vue&type=script&lang=js"
import style0 from "./ScopeSelect.vue?vue&type=style&index=0&id=4375d670&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4375d670",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4375d670')) {
      api.createRecord('4375d670', component.options)
    } else {
      api.reload('4375d670', component.options)
    }
    module.hot.accept("./ScopeSelect.vue?vue&type=template&id=4375d670&scoped=true", function () {
      api.rerender('4375d670', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ScopeSelect.vue"
export default component.exports